import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyNumbersFloat]'
})
export class OnlyNumbersFloatDirective {

  constructor() { }
  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Home', 'End'];
    const keyPressed = event.key;

    // Permitir números del 0 al 9, el punto y las teclas permitidas
    if (!/[\d.]/.test(keyPressed) && !allowedKeys.includes(keyPressed)) {
      event.preventDefault();
    }

    // Permitir solo un punto decimal en la entrada
    if (keyPressed === '.' && (event.target as HTMLInputElement).value.includes('.')) {
      event.preventDefault();
    }
  }
}
